// extracted by mini-css-extract-plugin
export default {"everyField":"FormPayrollSettings_everyField__gKK6X","weeksFieldLabel":"FormPayrollSettings_weeksFieldLabel__3kA80","weeksField":"FormPayrollSettings_weeksField__FuMsi"};